import { createStore } from 'vuex';

export default createStore({
  state: {
    lang: 'pt',
    txt_app: {},
    txt_primevue: {},
    param: { 
      setores: [],
      setoresAreas: [],
      setoresAreasDef: [],
    },
    prevRoute: null,
  }
});
